import { FetchModelResponse } from '@cian/http-api';

import { IAddOfferToComparisonResponseSchema } from 'shared/repositories/offers-comparison/entities/add_offer_to_comparison/AddOfferToComparisonResponseSchema';

export const mapAddOfferToComparisonResponse = (
  response: IAddOfferToComparisonResponseSchema,
): FetchModelResponse<200, 'json', IAddOfferToComparisonResponseSchema> => {
  return {
    statusCode: 200,
    response,
  };
};
